import { toJS } from "mobx";
import { observer } from "mobx-react";
import { useContext, useEffect, useReducer, useState } from "react";
import { MobXProviderContext } from "mobx-react";
import moment from "moment-timezone";
import {
  dateFormat,
  dateTimeFormatLong,
  deadlineFormat,
  longDateFormatWithLongDay,
  timeFormat,
} from "utils/helpers/dateTime";
import { handleKeyDown } from "utils/helpers/validation";
import { sanitizeAllowedChars } from "utils/helpers/string";
import classNames from "classnames";
import { isPresent } from "utils/helpers/array";
import { TIP_VALUES_DESKTOP, TIP_VALUES_MOBILE } from "utils/constants/common";
import TipButton from "components/TipButton";
import { preventMinus, preventPasteNegative } from "utils/helpers/validation";
import dateTime from "utils/helpers/dateTime";
import { useNavigate } from "react-router-dom";
import mealManagementStore from "mobXstore/mealManagementStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { ErrorWithSupport } from "components";
import Cookies from "js-cookie";
import {
  DisabledRadioButton,
  FileInputIcon,
  MasterCardIcon,
  RadioActive,
  RadioInActive,
  VisaCardIcon,
} from "assets/img";
import icon from "utils/helpers/icon";
import { AddCard } from "alerts";

const notificationMethods = [
  { id: "no", title: "No, only use these instructions for this order" },
  {
    id: "yes",
    title: "Yes, use for this and all future orders with this address",
  },
];

const NewGroupOrder = () => {
  const initialState = {
    groupOrderName: null,
    perPersonBudget: null,
    expectedAttendees: null,
    selectedDate: null,
    selectedTime: null,
    selectedDateUser: null,
    selectedTimeUser: null,
    times: [],
    userTimes: [],
    dateError: false,
    timeError: false,
    userDateError: false,
    userTimeError: false,
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    phone: "",
    error: false,
    phoneError: "",
    tip: "15",
    otherTip: "",
    deliveryInstructionsLevel: "no",
    emailError: "",
    locationCreditCards: null,
    defaultCard: null,
    expiredCardIds: null,
    temporaryCard: null,
    showTemporaryCard: false,
    temporaryCardSelected: false,
  };

  function reducer(state, action) {
    switch (action.type) {
      case "reset":
        return initialState;
    }
    return {
      ...state,
      [action.field]: action.value,
    };
  }

  const [provider, dispatch] = useReducer(reducer, initialState);

  const store = useContext(MobXProviderContext);
  const userStore = toJS(store?.userStore);
  const cartStore = toJS(store?.cartStore);
  const restaurantStore = toJS(store?.restaurantStore);
  const paymentInfoStore = toJS(store?.paymentInfoStore);
  const deliveryInfoStore = toJS(store?.deliveryInfoStore);
  const [addressDeliveryInstructions, setAddressDeliveryInstructions] =
    useState("");
  const [navigationResponse, setNavigationResponse] = useState(null);
  const [existingDeliveryAddress, setExistingDeliveryAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSupport, setErrorSupport] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorType, setErrorType] = useState("");
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [addCard, setAddCard] = useState(false);
  const [payByInvoice, setPayByInvoice] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [temporaryCardId, setTemporaryCardId] = useState("");

  let {
    selectedAddress,
    selectedDate,
    selectedTime,
    defaultLocation,
    enableInvoice,
    billingDetails,
  } = userStore ?? {};
  let { activeRestaurant } = restaurantStore;
  let { defaultSelectedCard, defaultPaymentMethodId } = paymentInfoStore;
  let { locationAddresses } = deliveryInfoStore;
  let { orderDeadline, orderDeadlineTime, currentGroupOrder } =
    mealManagementStore;

  let { cart } = cartStore ?? {};
  const router = null;
  const navigate = useNavigate();

  let {
    groupOrderName,
    perPersonBudget,
    expectedAttendees,
    selectedDateUser,
    selectedTimeUser,
    dateError,
    timeError,
    userDateError,
    userTimeError,
    otherTip,
    locationCreditCards,
    defaultCard,
    expiredCardIds,
    temporaryCard,
    showTemporaryCard,
    temporaryCardSelected,
  } = provider;

  const moveToRestaurantDetails = () => {
    navigate(-1);
    store.userStore?.setLoader(true);
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (Cookies.get("employee-id") == defaultLocation.value) {
      store.userStore.setLoader(true);
      setTimeout(() => {
        store.paymentInfoStore
          .getLocationCreditCards({
            location_id: defaultLocation?.organizationId,
          })
          .then((response) => {
            dispatch({
              field: "locationCreditCards",
              value: response?.payment_methods,
            });
            dispatch({
              field: "defaultCard",
              value:
                response?.customer?.invoice_settings?.default_payment_method,
            });
            store.userStore.setLoader(false);
          })
          .catch(() => store.userStore?.setLoader(false));
        store.userStore.setLoader(false);
      }, 1000);
    }
  }, [defaultLocation.organizationId, addCard]);

  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const expiredCards = [];
    let isCurrentDefaultExpired = false;

    const nonExpiredCards = locationCreditCards?.data?.filter((data) => {
      const expMonth = data.card.exp_month;
      const expYear = data.card.exp_year;

      const isExpired =
        expYear < currentYear ||
        (expYear === currentYear && expMonth < currentMonth);

      if (isExpired) {
        expiredCards.push(data.id);
        if (data?.id === defaultCard) {
          isCurrentDefaultExpired = true;
        }
        return false;
      }

      return true;
    });

    dispatch({
      field: "expiredCardIds",
      value: expiredCards,
    });

    if (isCurrentDefaultExpired && nonExpiredCards?.length > 0) {
      handleDefaultStripeCard(nonExpiredCards[0]?.id);

      dispatch({
        field: "defaultCard",
        value: nonExpiredCards[0]?.id,
      });
    }
  }, [locationCreditCards, defaultCard]);

  const handleDefaultStripeCard = (paymentID) => {
    store.paymentInfoStore.updateDefaultLocationCreditCards(paymentID, {
      location_id: defaultLocation?.organizationId,
      default: true,
    });
  };

  useEffect(() => {
    if (navigationResponse?.data?.attributes) {
      navigate(
        `/group/order_created/${navigationResponse?.data?.attributes?.id}`
      );
    }
  }, [navigationResponse]);

  useEffect(() => {
    if (selectedDate && dateError)
      dispatch({ field: "dateError", value: false });
    if (selectedTime && timeError)
      dispatch({ field: "timeError", value: false });
    if (selectedDateUser && userDateError)
      dispatch({ field: "userDateError", value: false });
    if (selectedTimeUser && userTimeError)
      dispatch({ field: "userTimeError", value: false });
  }, [selectedDate, selectedTime, selectedDateUser, selectedTimeUser]);

  useEffect(() => {
    if (isPresent(locationAddresses) && selectedAddress?.value) {
      const address = locationAddresses?.find(
        (address) => address.id === selectedAddress?.value
      );
      const deliveryInstruction = address?.attributes?.delivery_instructions;
      setAddressDeliveryInstructions(deliveryInstruction ?? "");
      setExistingDeliveryAddress(deliveryInstruction ?? "");
    }
  }, [store.userStore.isHydrated, router?.isReady]);

  useEffect(() => {
    dispatch({ field: "reset", value: null });
    if (currentGroupOrder?.attributes) {
      setValues();
    }

    if (defaultLocation?.role !== "team_admin") {
      store?.userStore?.setLoader(true);
      store.paymentInfoStore
        .getLocationCreditCards({
          location_id: defaultLocation?.organizationId,
        })
        .then(() => store?.userStore?.setLoader(false));
    }

    fetchOrderDeadline();
  }, []);

  useEffect(() => {
    if (selectedDate && selectedDateUser) {
      getGroupOrderTimes(selectedDate, true);
      getGroupOrderTimes(selectedDateUser, false);
    }
  }, [selectedDate, selectedDateUser]);

  useEffect(() => {
    if (selectedDate && selectedDateUser) {
      getGroupOrderTimes(selectedDateUser, false);
    }
  }, [selectedTime]);

  const setValues = () => {
    const attendees = currentGroupOrder?.attributes?.expected_attendees;
    const budget = currentGroupOrder?.attributes?.per_person_budget;

    dispatch({
      field: "groupOrderName",
      value: currentGroupOrder?.attributes?.title,
    });

    dispatch({
      field: "perPersonBudget",
      value: budget,
    });

    dispatch({
      field: "expectedAttendees",
      value: attendees,
    });

    const adminDate = new Date(currentGroupOrder?.attributes?.admin_deadline);
    const isFutureDate = moment(adminDate).isSameOrAfter(moment());
    const adminTime = moment(
      currentGroupOrder?.attributes?.admin_deadline,
      deadlineFormat
    ).format(timeFormat);
    const adminDeadline = `${moment(adminDate).format(
      dateFormat
    )} ${adminTime}`;

    if (isFutureDate) {
      dispatch({
        field: "selectedDate",
        value: adminDate,
      });

      getGroupOrderTimes(adminDate, true, {
        expectedAttendees: attendees,
        perPersonBudget: budget,
      });

      getDatesForGroupOrder(attendees, budget, true);

      dispatch({
        field: "selectedTime",
        value: adminTime,
      });

      const userDate = new Date(
        currentGroupOrder?.attributes?.attendee_deadline
      );

      dispatch({
        field: "selectedDateUser",
        value: userDate,
      });

      dispatch({
        field: "selectedTimeUser",
        value: moment(
          currentGroupOrder?.attributes?.attendee_deadline,
          deadlineFormat
        ).format(timeFormat),
      });

      getDatesForGroupOrder(attendees, budget, false, adminDeadline);

      getGroupOrderTimes(userDate, false, {
        expectedAttendees: attendees,
        perPersonBudget: budget,
        adminDate,
        adminTime,
      });
    }
  };

  function parseDeadline(deadline) {
    if (typeof deadline !== "string") return null;

    // Remove 1st, 2nd, 3rd, 4th... from the date string
    const cleaned = deadline?.replace(/(\d+)(st|nd|rd|th)/, "$1");
    const date = new Date(cleaned);

    if (isNaN(date?.getTime())) return null;
    return date;
  }

  function isDeadlinePassed(deadline) {
    const deadlineDate = parseDeadline(deadline);
    if (!deadlineDate) return false; // invalid or missing date → treat as not passed

    const now = new Date();
    return deadlineDate < now;
  }

  const submit = (e) => {
    e.preventDefault();

    if (!selectedDate) {
      store.userStore?.setErrorAlert(true, {
        title: "Please select a valid date.",
      });
      return;
    }

    if (!selectedTime) {
      store.userStore?.setErrorAlert(true, {
        title: "Please select a valid time",
      });
      return;
    }

    fetchOrderDeadline();

    if (isDeadlinePassed(orderDeadline)) {
      store.userStore?.setErrorAlert(true, {
        title:
          "The group order cannot be created because the deadline has passed.",
      });
      return;
    }

    let payload = {
      meal_series: {
        service: "grouped",
        name: groupOrderName,
        address_id: selectedAddress?.value,
        subsidy: perPersonBudget,
        expected_bags: expectedAttendees,
        status: "active",
        cutoff: dateTime.onlyTimeString(orderDeadlineTime),
        start_date: moment(selectedDate).format("YYYY-MM-DD"),
        dates_to_add: [moment(selectedDate).format("YYYY-MM-DD")],
        target_time: dateTime.to24hourformat(selectedTime),
        payment_method: payByInvoice
          ? "invoice"
          : provider.defaultCard
          ? "credit_card"
          : provider.temporaryCardSelected
          ? "credit_card"
          : null,
        meals_attributes: [
          {
            subsidy: perPersonBudget,
            meal_date: moment(selectedDate).format("YYYY-MM-DD"),
            target_time: dateTime.to24hourformat(selectedTime),
            cutoff: orderDeadlineTime,
            tip: provider?.tip == "Other" ? provider?.otherTip : 0,
            tip_percentage: provider?.tip === "Other" ? 0 : provider?.tip,
            shipments_attributes: [
              {
                menu_id: activeRestaurant?.attributes?.id,
                service: "grouped",
                source_of_business: "hungerhub",
              },
            ],
            invitation_links_attributes: [
              {
                subsidy: perPersonBudget,
              },
            ],
          },
        ],
      },
    };

    if (provider.deliveryInstructionsLevel == "no") {
      payload.meal_series.delivery_instructions = addressDeliveryInstructions;
    }

    if (temporaryCardSelected && temporaryCardId) {
      payload.meal_series.stripe_card_id = temporaryCardId;
    } else if (defaultPaymentMethodId) {
      payload.meal_series.stripe_card_id = defaultPaymentMethodId;
    }

    store?.userStore?.setLoader(true);

    if (currentGroupOrder?.attributes?.slug) {
      store?.mealManagementStore
        ?.updateGroupOrder(currentGroupOrder?.attributes?.slug, payload)
        .then((response) => {
          store?.userStore?.setLoader(false);

          setNavigationResponse(response);
        });
    } else {
      let params = {
        location_id: defaultLocation?.organizationId,
      };

      if (provider.deliveryInstructionsLevel == "yes")
        params.delivery_instructions = addressDeliveryInstructions;

      store?.mealManagementStore
        .createGroupOrder(payload, params)
        .then((response) => {
          store?.userStore?.setLoader(false);
          setNavigationResponse(response);
        });
    }
  };

  const getDatesForGroupOrder = (attendees, budget, adminDeadline) => {
    const _expectedAttendees = attendees || expectedAttendees;
    const _perPersonBudget = budget || perPersonBudget;

    if (_expectedAttendees && _perPersonBudget && router?.query?.menu_id) {
      let payload = {
        menu_id: router?.query?.menu_id,
        attendee: _expectedAttendees,
        budget_per_attendee: _perPersonBudget,
        order_date: moment(cart?.cartDate).format(dateFormat),
        delivery_time: cart?.cartTime,
        admin: true,
      };

      store?.groupOrderStore.getDatesForGroupOrder(payload);
    }
  };

  const getGroupOrderTimes = (date, data) => {
    let payload = {
      menu_id: router?.query?.menu_id,
      attendee: Math.abs(data?.expectedAttendees ?? expectedAttendees),
      budget_per_attendee: data?.perPersonBudget ?? perPersonBudget,
      selected_date: moment(cart?.cartDate).format(dateFormat),
      current_date_time: moment().format(dateTimeFormatLong),
      delivery_time: cart?.cartTime,
      admin: true,
      admin_date: moment(date).format(dateFormat),
    };

    store?.groupOrderStore.getTimesForGroupOrder(payload).then((response) => {
      dispatch({
        field: "times",
        value: response?.timeslots,
      });

      const isPastAdminDeadline = moment(
        `${moment(selectedDate).format(dateFormat)} ${selectedTime}`,
        "YYYY-MM-DD h:mm a"
      ).isBefore(moment());

      const isPastUserDeadline = moment(
        `${moment(selectedDateUser).format(dateFormat)} ${selectedTimeUser}`,
        "YYYY-MM-DD h:mm a"
      ).isBefore(moment());

      if (
        selectedTime &&
        (!isPresent(response?.timeslots) || isPastAdminDeadline)
      ) {
        dispatch({ field: "selectedTime", value: null });
      }
    });
  };

  const fieldsValidated = () => {
    return (
      groupOrderName &&
      perPersonBudget &&
      expectedAttendees &&
      errorType == null &&
      perPersonBudget > 0 &&
      expectedAttendees > 0
    );
  };

  const fetchOrderDeadline = () => {
    if (provider.expectedAttendees && provider.perPersonBudget) {
      const _date = moment(selectedDate).format("YYYY-MM-DD");
      const _time = dateTime.to24hourformat(selectedTime);
      const params = {
        budget: provider.expectedAttendees * provider.perPersonBudget,
        target_time: dateTime.to24hourformat(_time),
        meal_date: _date,
      };

      if (_date && _time) {
        store?.userStore?.setLoader(true);

        store?.mealManagementStore
          .fetchOrderDeadline(activeRestaurant?.attributes?.id, params)
          .then((response) => {
            if (response?.data && !response?.data?.valid) {
              if (
                response?.data?.message?.includes("restaurant_need_more_time")
              ) {
                setErrorSupport(true);
                setErrorMessage(
                  "Based on the budget for this order, the restaurant will need more time to prepare this order."
                );
                setErrorTitle(
                  "The restaurant needs more time to prepare this order"
                );
                setErrorType(response?.data?.message);
              } else if (
                response?.data?.message?.includes("minimum_amount_not_met")
              ) {
                setErrorSupport(true);
                setErrorMessage(
                  `Based on the budget for this order, the restaurants minimum of $${response?.data?.minimum_amount} will not be met. Please increase the budget or select another restaurant.`
                );
                setErrorTitle(
                  "Projected order value is below the order minimum"
                );
                setErrorType(response?.data?.message);
              }
            }

            store?.userStore?.setLoader(false);
          });
      }
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setErrorType(null);
      fetchOrderDeadline();
    }, 2500);

    return () => clearTimeout(delayDebounce);
  }, [provider.expectedAttendees, provider.perPersonBudget]);

  const handleTemporaryCard = (card) => {
    setTemporaryCardId(card?.id);
    dispatch({ field: "temporaryCard", value: card });
    dispatch({ field: "showTemporaryCard", value: true });
    dispatch({ field: "temporaryCardSelected", value: true });
  };

  return (
    <>
      <div
        className="flex justify-center bg-white min-h-[calc(100vh-200px)] mx-auto p-5 sm:p-10 md:p-8 sm:mt-[30px] md:mt-0"
        style={{ maxWidth: "1440px" }}
      >
        <div className="flex flex-col mt-[2%] w-full pb-40 sm:pb-0">
          <div
            className="text-[#232777] text-base font-inter-normal leading-tight cursor-pointer"
            onClick={moveToRestaurantDetails}
          >
            <FontAwesomeIcon
              icon={faAngleLeft}
              style={{ width: 14, height: 14 }}
            />
            <span className="ml-2">Back to restaurant</span>
          </div>

          <div className="flex flex-col text-center">
            <span className="text-md font-inter-semibold text-hh-accent-light">
              Step 2 of {defaultPaymentMethodId ? 3 : 4}
            </span>

            <span className="text-[24px] font-inter-semibold text-black-light mt-1.5">
              Complete Group Order Details
            </span>
          </div>

          <div className="border border-zinc-200 rounded-xl w-full d-col p-[12px] max-w-[593px] mt-[32px]">
            <div className="mb-[12px] text-[#3a3a3a]">
              <small className="font-inter-medium text-base text-heading">
                Restaurant:{" "}
              </small>
              <span className="font-inter-normal text-base leading-tight">
                {activeRestaurant?.attributes?.display_name}
              </span>
            </div>

            <div className="mb-[12px] text-[#3a3a3a]">
              <small className="font-inter-medium text-base text-heading">
                Delivery Address:{" "}
              </small>
              <span className="font-inter-normal text-base leading-tight">
                {selectedAddress?.label}
              </span>
            </div>

            <div className="mb-[12px] text-[#3a3a3a]">
              <small className="font-inter-medium text-base text-heading">
                Delivery Date:{" "}
              </small>
              <span className="font-inter-normal text-base leading-tight">
                {moment(selectedDate).format(longDateFormatWithLongDay)}
              </span>
            </div>

            <div className="mb-[12px] text-[#3a3a3a]">
              <small className="font-inter-medium text-base text-heading">
                Delivery Time:{" "}
              </small>
              <span className="font-inter-normal text-base leading-tight">
                {selectedTime}
              </span>
            </div>

            <div className="mb-[12px] text-[#3a3a3a]">
              <small className="font-inter-medium text-base text-heading">
                Order deadline:{" "}
              </small>
              <span className="font-inter-normal text-base leading-tight">
                {orderDeadline || "-"}
              </span>
            </div>

            <div
              className="mb-[12px] text-[#3a3a3a] inline-flex cursor-pointer"
              onClick={() => {
                setShowPaymentMethods((prev) => !prev);
                setIsOpen((prev) => !prev);
              }}
            >
              <small className="font-inter-medium text-indigo-500 text-base text-heading">
                Selected payment method{" "}
              </small>

              <span className="flex items-center text-indigo-500 gap-2">
                {!payByInvoice && defaultPaymentMethodId
                  ? `: ${defaultSelectedCard?.brand
                      ?.replace(/_/g, " ")
                      ?.replace(/\b\w/g, (c) => c.toUpperCase())} ending in ${
                      defaultSelectedCard?.last4
                    }`
                  : payByInvoice
                  ? ": Invoice"
                  : ": None selected"}
                <FontAwesomeIcon
                  icon={isOpen ? faChevronUp : faChevronDown}
                  className="w-3 h-3"
                />
              </span>
            </div>

            {showPaymentMethods && (
              <>
                <div className="bg-light-gray p-3 rounded-xl">
                  <p className="text-slate-700 font-inter-medium">
                    Credit cards on file
                  </p>

                  {locationCreditCards ? (
                    locationCreditCards?.data?.map((data, index) => {
                      const isExpiredCard = expiredCardIds?.includes(data?.id);

                      return (
                        <div
                          className={classNames(
                            "rounded-xl mt-[16px] px-[12px] py-[12px] d-row justify-between",
                            "bg-white border border-gray-300"
                          )}
                          key={index}
                        >
                          <div
                            key={"photo"}
                            className="w-full flex items-center"
                          >
                            <div
                              className={classNames("flex items-center", {
                                "cursor-pointer": !isExpiredCard,
                              })}
                              onClick={() => {
                                if (!isExpiredCard) {
                                  setPayByInvoice(false);
                                  handleDefaultStripeCard(data?.id);
                                  dispatch({
                                    field: "defaultCard",
                                    value: data?.id,
                                  });
                                  dispatch({
                                    field: "temporaryCardSelected",
                                    value: false,
                                  });
                                }
                              }}
                            >
                              <img
                                alt="radio-button"
                                src={
                                  isExpiredCard && data?.id !== defaultCard
                                    ? DisabledRadioButton
                                    : data?.id == defaultCard &&
                                      !payByInvoice &&
                                      !temporaryCardSelected
                                    ? RadioActive
                                    : RadioInActive
                                }
                              />
                            </div>

                            <div className="w-full flex justify-between">
                              <div className="d-row items-center ml-3">
                                <img
                                  className="relative w-[40px] h-[40px]"
                                  alt="Frame"
                                  src={
                                    data?.card?.display_brand?.toLowerCase() ===
                                    "visa"
                                      ? VisaCardIcon
                                      : data?.card?.display_brand?.toLowerCase() ===
                                        "mastercard"
                                      ? MasterCardIcon
                                      : icon.cardBrandIcons[
                                          data?.card?.display_brand?.toLowerCase()
                                        ] || icon.cardBrandIcons.default
                                  }
                                />

                                <div className="d-col ml-3">
                                  <small
                                    className={classNames(
                                      "text-sm font-inter-medium",
                                      isExpiredCard
                                        ? "text-orange-400"
                                        : "text-slate-700"
                                    )}
                                  >
                                    <div>**** {data?.card?.last4}</div>
                                    <div className="text-slate-500 font-inter-normal text-sm">
                                      Expires{" "}
                                      {`${
                                        data?.card?.exp_month
                                      }/${data?.card?.exp_year
                                        .toString()
                                        .slice(-2)}`}
                                    </div>
                                    {isExpiredCard && (
                                      <small className="text-orange-400 text-sm font-inter-medium italic">
                                        Expired
                                      </small>
                                    )}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  )}

                  {showTemporaryCard && (
                    <div className="bg-white border border-zinc-200 h-16 rounded-lg mt-[12px] px-[12px] py-[16px] d-row justify-between">
                      <div key={"photo"} className="flex items-center">
                        <div
                          className="flex cursor-pointer"
                          onClick={() => {
                            setPayByInvoice(false);

                            dispatch({
                              field: "temporaryCardSelected",
                              value: true,
                            });
                          }}
                        >
                          <img
                            alt="radio-button"
                            src={
                              temporaryCard && temporaryCardSelected
                                ? RadioActive
                                : RadioInActive
                            }
                          />
                          <div className="d-row items-center ml-3">
                            <img
                              className="relative w-[40px] h-[40px]"
                              alt="Frame"
                              src={
                                temporaryCard?.card?.brand?.toLowerCase() ===
                                "visa"
                                  ? VisaCardIcon
                                  : temporaryCard?.card?.brand?.toLowerCase() ===
                                    "mastercard"
                                  ? MasterCardIcon
                                  : icon.cardBrandIcons[
                                      temporaryCard?.card?.brand?.toLowerCase()
                                    ] || icon.cardBrandIcons.default
                              }
                            />

                            <div className="d-col ml-3">
                              <small className="text-sm text-slate-700 font-inter-medium">
                                **** {temporaryCard?.card?.last4}
                              </small>

                              <small className="text-sm text-slate-500 font-inter-normal">
                                Expires{" "}
                                {`${
                                  temporaryCard?.card?.exp_month
                                }/${temporaryCard?.card?.exp_year
                                  ?.toString()
                                  ?.slice(-2)}`}
                              </small>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  )}

                  <button
                    className="border border-indigo-500 w-full text-indigo-500 px-3 py-2 mt-4 rounded-md bg-white"
                    onClick={() => setAddCard(true)}
                  >
                    + Add a new card
                  </button>

                  {enableInvoice == "enabled" && (
                    <>
                      <p className="text-slate-700 font-inter-medium mt-[12px]">
                        Pay with invoice
                      </p>
                      <div className="bg-white border border-zinc-200 rounded-xl mt-[12px] px-[12px] py-[16px] d-row justify-between">
                        <div className="d-row items-center">
                          <div
                            className={classNames("flex items-center", {
                              "cursor-pointer": true,
                            })}
                            onClick={() => {
                              setPayByInvoice(true);
                              dispatch({
                                field: "temporaryCardSelected",
                                value: false,
                              });
                            }}
                          >
                            <img
                              alt="radio-button"
                              src={payByInvoice ? RadioActive : RadioInActive}
                            />
                          </div>

                          <img
                            className="relative w-[40px] h-[40px] ml-3"
                            alt="Frame"
                            src={FileInputIcon}
                          />

                          <div className="d-col ml-2 gap-[4px]">
                            <small className="text-sm text-dark-gray font-inter-medium">
                              Invoice details
                            </small>

                            <small className="text-slate-500 text-sm font-inter-normal leading-[14px] tracking-tight">
                              {billingDetails?.account_billing_name}
                            </small>

                            <small className="text-slate-500 text-sm font-inter-normal leading-[14px] tracking-tight">
                              {billingDetails?.account_billing_address}
                            </small>

                            <small className="text-slate-500 text-sm font-inter-normal leading-[14px] tracking-tight">
                              {billingDetails?.account_billing_emails?.map(
                                (email, index) => {
                                  return <p className="mb-1">{email}</p>;
                                }
                              )}
                            </small>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          <form onSubmit={submit} autoComplete="off" className="w-[593px]">
            <div className="flex flex-col mt-8">
              <span className="text-md2 font-inter-semibold">
                Group order name
              </span>

              <input
                required
                name={"groupOrderNameField"}
                className="input-gray-bg focus:ring-0 address-inputs my-0 rounded-xl text-md w-full bg-background pl-4 mt-3"
                placeholder="ex. Friday lunch & Learn"
                value={groupOrderName}
                onChange={(e) =>
                  dispatch({
                    field: "groupOrderName",
                    value: sanitizeAllowedChars(e.target.value),
                  })
                }
              />
            </div>

            <div className="flex flex-col mt-6">
              <div className=" flex flex-col sm:grid sm:grid-cols-2 sm:gap-3">
                <div className="d-col">
                  <span className="text-md2 font-inter-semibold mb-3">
                    Budget per person
                  </span>

                  <div className="relative w-full">
                    <span
                      className={`absolute left-3 top-1/2 -translate-y-1/2 text-md ${
                        perPersonBudget ? "text-black" : "text-gray-400"
                      }`}
                    >
                      $
                    </span>
                    <input
                      required
                      type="number"
                      name="perPersonBudgetField"
                      className="pl-6 input-gray-bg focus:ring-0 address-inputs my-0 rounded-xl text-md w-full bg-background"
                      value={perPersonBudget}
                      onWheelCapture={(e) => e.target.blur()}
                      onKeyDown={handleKeyDown}
                      placeholder="0.00"
                      onChange={(e) =>
                        dispatch({
                          field: "perPersonBudget",
                          value: e.target.value,
                        })
                      }
                      onBlur={(e) => {
                        const roundedValue = parseFloat(e.target.value).toFixed(
                          2
                        );
                        if (!isNaN(roundedValue)) {
                          dispatch({
                            field: "perPersonBudget",
                            value: roundedValue,
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="d-col">
                  <span className="text-md2 font-inter-semibold mb-3">
                    Expected number of invitees
                  </span>
                  <input
                    required
                    name={"expectedAttendeesField"}
                    className="input-gray-bg focus:ring-0 address-inputs my-0 rounded-xl text-sm w-full !text-md bg-background pl-4"
                    value={expectedAttendees}
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={handleKeyDown}
                    max={300}
                    type="number"
                    onChange={(e) =>
                      dispatch({
                        field: "expectedAttendees",
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="mt-[16px]">
              <div className="flex flex-col w-full items-start justify-between">
                <span className="text-md2 font-inter-semibold mb-3">Tip</span>

                <span className="text-sm mt-[6px]">
                  This will be used to calculate the tip amount based on your
                  group order items total. You can update this amount later in
                  your admin panel.
                </span>
              </div>

              <div className="hidden sm:flex w-full justify-between flex-wrap items-center">
                {TIP_VALUES_DESKTOP?.map((tipValue) => (
                  <TipButton
                    key={`${tipValue}-tip`}
                    onClick={() =>
                      dispatch({
                        field: "tip",
                        value: tipValue,
                      })
                    }
                    tipValue={tipValue}
                    tip={provider?.tip}
                  />
                ))}
              </div>

              <div className="flex sm:hidden w-full flex-wrap items-center">
                {TIP_VALUES_MOBILE?.map((tipValue) => (
                  <TipButton
                    key={`${tipValue}-tip-mob`}
                    onClick={() =>
                      dispatch({
                        field: "tip",
                        value: tipValue,
                      })
                    }
                    tipValue={tipValue}
                    tip={provider?.tip}
                  />
                ))}
              </div>

              {provider.tip == "Other" && (
                <div className="flex mt-[16px] mb-3 space-x-5">
                  <div className="flex items-center text-md rounded-xl bg-background w-full py-2 px-3 h-12 border border-border-gray">
                    <span>$</span>

                    <input
                      className="text-sm bg-background h-[46px] w-full focus:outline-none"
                      value={otherTip}
                      type="number"
                      min="0"
                      step=".01"
                      onKeyDown={preventMinus}
                      onPaste={preventPasteNegative}
                      onChange={(e) =>
                        dispatch({
                          field: "otherTip",
                          value:
                            e.target.value !== ""
                              ? Math.abs(e.target.value)
                              : e.target.value,
                        })
                      }
                      onBlur={(e) => {
                        const roundedValue = parseFloat(e.target.value).toFixed(
                          2
                        );
                        if (!isNaN(roundedValue)) {
                          dispatch({
                            field: "otherTip",
                            value: roundedValue,
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <span className="text-md2 font-inter-semibold mt-[16px]">
              Delivery Instructions (optional)
            </span>

            <textarea
              placeholder="ex. Park in the back entrance and call us when you arrive."
              className="input-gray-bg resize mt-3 focus:ring-0 address-inputs my-0 h-[130px] rounded-xl text-md w-full bg-background pl-4"
              type="text"
              value={addressDeliveryInstructions}
              onChange={(e) =>
                setAddressDeliveryInstructions(
                  sanitizeAllowedChars(e.target.value)
                )
              }
            />

            {existingDeliveryAddress !== addressDeliveryInstructions && (
              <fieldset>
                <p className="text-md2 font-inter-semibold mt-[16px]">
                  Should we apply these instructions to all deliveries with this
                  address?
                </p>

                <div className="mt-[12px] space-y-2">
                  {notificationMethods.map((notificationMethod) => (
                    <div
                      key={notificationMethod.id}
                      className="flex items-center"
                    >
                      <input
                        id={notificationMethod.id}
                        name="notification-method"
                        type="radio"
                        defaultChecked={
                          provider.deliveryInstructionsLevel ===
                          notificationMethod.id
                        }
                        onChange={(e) => {
                          dispatch({
                            field: "deliveryInstructionsLevel",
                            value: e.target.id,
                          });
                        }}
                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                      />
                      <label
                        htmlFor={notificationMethod.id}
                        className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                      >
                        {notificationMethod.title}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            )}

            <div className="fixed sm:static p-5 sm:p-0 sm:flex bg-white bottom-0 right-0 left-0 mt-6 w-full">
              <button
                type="submit"
                disabled={!fieldsValidated()}
                className={classNames({
                  "rounded-md p-6 w-full text-white btn-style text-md font-inter-medium": true,
                  "bg-secondary-text ": !fieldsValidated(),
                  "bg-hh-accent-dark hover:bg-hh-accent-light":
                    fieldsValidated(),
                })}
              >
                Continue
              </button>
            </div>
          </form>
        </div>

        {errorSupport && (
          <ErrorWithSupport
            visible={errorSupport}
            setModal={setErrorSupport}
            contactSupport={true}
            title={errorTitle}
            body={errorMessage}
            hideCancel={true}
            rightButtonText={"OK"}
            onClickRightButton={() => {
              setErrorSupport(false);
            }}
            handleLinkClick={() => {
              store.userStore.setFreshChatOpen(true);
            }}
            errorType={errorType}
          />
        )}

        <AddCard
          avoidClose
          visible={addCard}
          setModal={setAddCard}
          handleTemporaryCard={handleTemporaryCard}
          handlePaymentMethod={() =>
            dispatch({
              field: "paidByInvoice",
              value: false,
            })
          }
          isCheckout={true}
          newGroupOrder={true}
          handleTemporaryCardId={handleTemporaryCard}
        />
      </div>
    </>
  );
};

export default observer(NewGroupOrder);
